<template>
   <div class="c-step-intro">
     <div class="c-step-intro__content">
<p>
  Thank you for completing the online DIY form! The information you provided has successfully been handed over to our design team. They’ll begin working on it as soon as possible, and you can expect a first digital proof shortly.<br>
  <br>
  If you have any questions or comments, reach out to our coordinator at <a href="mailto:coordinator@persoonlijkproefschrift.nl">coordinator@persoonlijkproefschrift.nl</a>.
</p>
     </div>
  </div>    
</template>

<script>
export default {
}
</script>

<style>

</style>